import { useEffect, useState } from "react";
import Cookie from "js-cookie";

export function useDoNotShowGBB(): boolean {
  const [doNotShowGBB, setDoNotShowGBB] = useState(false);

  useEffect(() => {
    setDoNotShowGBB(Cookie.get("doNotShowGBB") === "true");
  }, []);

  return doNotShowGBB;
}
